import { NgModule } from '@angular/core';
import { MenuNuevoComponent } from './menu-nuevo.component';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// import { MatSnackBarModule } from '@angular/material/snack-bar';
@NgModule({
  declarations: [
    // ... tus otros componentes ...
    MenuNuevoComponent
  ],
  imports: [
    MatProgressSpinnerModule,
    CommonModule,
    MatDialogModule
  ],
  // ...
})
export class MenuNuevoModule {}


